import { FC } from "react";
import { _ } from "../../utils/helpers";
import { CardElement } from "@stripe/react-stripe-js";
import { Icon } from "../../parts/Icon";
import { useApp } from "../../context/useApp";

interface PaymentDetailsProps {
    setStripeComplete: React.Dispatch<React.SetStateAction<boolean>>
} 

export const PaymentDetails: FC<PaymentDetailsProps> = ({setStripeComplete}) => {
    const { state: { booking } } = useApp()
    console.log('booking.journey: ', booking.journey)

    return (
         <fieldset id="payment-details" className="pt-8 pb-7 px-7 r3 mb-8 mt-0">
               <legend className="text s20-600 mb-7">{_('5pi_enter__')}</legend>
               <div className="compound-input">
                  <CardElement 
                     options={{hidePostalCode: true}}
                     onChange={event => setStripeComplete(event.complete)}
                  />
               </div>
               <div className={`df aic jcfe mt-4 d-ib`} aria-hidden>
                  <p className="text soft s14-500 mr-7 upper nw">{_('5su_secur__')}: </p>
                  <div className="df aic">
                     <Icon icon="visa" className="mr-5" />
                     <Icon icon="mastercard" />
                  </div>
               </div>
         </fieldset>
         
    ) 
}
